<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-07-31 11:46:20
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-08 10:02:49
-->
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-13 09:57:02
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-27 09:56:12
-->
<template>
  <div id="box" class="box">
    <div id="left" :style="{height:`${heightLeft}px`}" class="left">
      <div style="font-weight:600;" class="title">组织机构</div>
      <div class="search">
        <a-input-search
          v-model:value="value"
          placeholder="搜索组织名称"
          size="large"
        >
          <template #enterButton>
            <img @click="search" class="img" src="@/assets/images/search.jpg" />
          </template>
        </a-input-search>
      </div>
       <a-spin :spinning="treeLoading">
      <div class="ant-tree">
        <a-tree
          ref="tree"
          :style="{height:`${heightLeft-100}px`,overflowY:'auto',overflowX:'hidden'}"
          show-line
          :tree-data="treeData"
          v-if="treeData.length > 0"
          @select="onSelect"
          :auto-expand-parent="isCloseAll"
          :defaultExpandedKeys="defaultExpandedKeys"
          :selectedKeys="checkedKeys"
          :expanded-keys="expandedKeys"
          :default-expanded-keys="columnOpenIds"
          @expand="onExpand"
        >
          <template  slot-scope="text" slot="child">
               <a-icon   class="icon-box-img"  type="link" />
           </template>
  	     
        </a-tree>
      </div>
      </a-spin>
    </div>
     <div id="resize" :style="{height:`${heightLeft}px`}"></div>
    <div id="right" class="right">
      <div class="right-title-box">
           <div style="font-weight: 600;" class="right-name">报备查看-{{ organizationName }}</div>
      </div>
      <div class="right-flex">
        <div class="search">
           
                 <a-range-picker  style="margin-right:8px;max-width:350px"  v-model="timeTwo" format="YYYY-MM-DD"/>
          <el-select
            clearable
            style="margin-left: 10px"
            v-model="applyStage"
            placeholder="阶段"
          >
            <el-option label="第一阶段" value="0"> </el-option>
            <el-option label="第二阶段" value="1"> </el-option>
            <el-option label="第三阶段" value="2"> </el-option>
        </el-select>
          <el-select
              clearable
              style="margin-left: 10px"
              v-model="applicationSource"
              placeholder="申请来源"
          >
            <el-option label="全部来源" :value="null"> </el-option>
            <el-option label="申请清单（线上）" value="0"> </el-option>
            <el-option label="申请报备（线下）" value="1"> </el-option>
          </el-select>
         <el-select
            clearable
            style="margin-left: 10px"
            clearable
            v-model="administrativeReview"
            placeholder="行政复议"
          >
            <el-option label="行政复议全部" value=""> </el-option>
            <el-option label="行政复议未产生" value="0"> </el-option>
            <el-option label="行政复议已产生" value="1"> </el-option>
        </el-select>
         <el-select
            clearable
            style="margin-left: 10px"
            clearable
            v-model="administrativeProceeding"
            placeholder="行政诉讼"
          >
           
            <el-option label="行政诉讼全部" value=""> </el-option>
            <el-option label="行政诉讼未产生" value="0"> </el-option>
            <el-option label="行政诉讼已产生" value="1"> </el-option>
        </el-select>
          <a-input
            v-model:value="valueName"
            placeholder="按申请人搜索"
            style="max-width:173px;margin-left: 10px"
          />
            <el-button class="search-box" type="primary"  @click="listSearch"
          ></span>查询</el-button
        >
        </div>
      </div>
      <coententTable
        :y="height"
        @onShowSizeChange="onShowSizeChange"
        :columns="columns"
        :dataSource="dataSource"
        :customSlot="customSlot"
        :isSelectRow="isSelectRow"
        @selectedRowKeys="selectedRowKeys"
        @handleSizeChange="handleSizeChange"
        :loading="loading"
        :rowKeys="rowKeys"
      >
       <template v-slot:applyStage="scopeVal">
        <span v-if="scopeVal.scope.applyStage == 0">第一阶段</span>
        <span v-if="scopeVal.scope.applyStage == 1">第二阶段</span>
        <span v-if="scopeVal.scope.applyStage == 2">第三阶段</span>
     </template>
        <template v-slot:applicationSource="scopeVal">
          <span v-if="scopeVal.scope.applicationSource == 0">申请清单（线上）</span>
          <span v-if="scopeVal.scope.applicationSource == 1">申请报备（线下）</span>
        </template>
      <template v-slot:administrativeReview="scopeVal">
        {{scopeVal.scope.administrativeReview==0?'未产生':scopeVal.scope.administrativeReview==1?'已产生':'—'}}
     </template>
     <template v-slot:answerTime="scopeVal">
         {{scopeVal.scope.answerTime?scopeVal.scope.answerTime:'—'}}
     </template>
      <template v-slot:administrativeProceeding="scopeVal">
         {{scopeVal.scope.administrativeProceeding==0?'未产生':scopeVal.scope.administrativeProceeding==1?'已产生':'—'}}
     </template>
        <template v-slot:operation="scopeVal">
           <div v-if="codeData.indexOf('416') != -1" @click="see(scopeVal.scope)" style="display: flex">
               <div
            class="btnTwo"
            style="margin-right:14px;">查看</div
          >
           </div>
        </template>
      </coententTable>
      <div id="pagination" class="pagination">
        <a-pagination
          :current="pagination.current"
          :pageSize="pagination.pageSize"
          show-size-changer
          show-quick-jumper
          :total="pagination.total"
          @change="onShowSizeChange"
          @showSizeChange="handleSizeChange"
          :page-size-options="pagination.pageSizeOptions"
          :show-total="(total) => `共 ${pagination.total} 条`"
        />
      </div>
    </div>
    <Detail :visible="visibleDeils" :item="itemData" @closeTwo="closeTwo" @close="close"/>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import Detail from './detail.vue';
import {
  tree,
  acceptListPage,
  findListPage
} from "../index";
export default {
  data() {
    return {
      value: "",
      valueName: "",
      visibleDeils:false,
      height: 0,
      heightLeft: 0,
      isCloseAll: false,
      selectedKeys: [],
      treeData: [],
      timeTwo: [],
      columns: [
        {
          title: "申请人姓名",
          dataIndex: "name",
          ellipsis: true,
          customCell: (column) => {
            return {
              style: {
                "min-width": "220px",
                "max-width": "220px",
              },
            };
          },
          customHeaderCell: (column) => {
            return {
              style: {
                "min-width": "220px",
                "max-width": "220px",
              },
            };
          },
        },
        {
          title: "阶段",
          dataIndex: "applyStage",
          width: 120,
          ellipsis: true,
           scopedSlots: { customRender: "applyStage" },
        },
        {
          title:"受理机关",
          dataIndex: "disposeOffice",
          width: 150,
          scopedSlots: {customRender: "disposeOffice"},
        },
        {
          title: "申请来源",
          dataIndex: "applicationSource",
          width: 150,
          ellipsis: true,
          scopedSlots: {customRender: "applicationSource"}
        },
         {
          title: "申请日期",
          dataIndex: "applyTime",
          ellipsis: true,
          width: 150,
           scopedSlots: { customRender: "applyTime" },
        },
         {
          title: "答复日期",
          dataIndex: "answerTime",
          ellipsis: true,
          width: 150,
           scopedSlots: { customRender: "answerTime" },
        },
        {
          title: "行政复议",
          dataIndex: "administrativeReview",
           scopedSlots: { customRender: "administrativeReview" },
          width: 150,
          ellipsis: true,
        },
        {
          title: "行政诉讼",
          dataIndex: "administrativeProceeding",
          width: 150,
          ellipsis: true,
           scopedSlots: { customRender: "administrativeProceeding" },
        },
        {
          title: "报备人",
          dataIndex: "stageName",
          width: 120,
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 120,
          fixed: "right",
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      organizationId: "",
      customSlot: [
        {
          name: "administrativeReview",
          customRender: "administrativeReview",
        },
        {
          name: "applyStage",
          customRender: "applyStage",
        },
        {
          name:"applicationSource",
          customRender: "applicationSource"
        },
         {
          name: "answerTime",
          customRender: "answerTime",
        },
        {
          name: "administrativeProceeding",
          customRender: "administrativeProceeding",
        },
      ],
      organizationName: "",
      isSelectRow: true,
      rowKeys: [],
      dataType:'',
      loading: false,
      time: "",
      selectDatas: [],
      checkedKeys: [],
      codeData: [],
      columnOpenIds: [],
      defaultExpandedKeys: [],
      treeLoading: false,
      oldThreeData: [],
      expandedKeys: [],
      itemData:{},
      applyStage:'',
      applicationSource:"",
      administrativeReview:'',
      administrativeProceeding:'',

    };
  },
  components: {
    coententTable,
    Detail
  },
  watch: {
    value(val) {
       this.treeData = this.oldThreeData;
      this.search();
    },
  },
  mounted() {
    this.getThreeList();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
    this.heightLeft = `${document.documentElement.clientHeight - 200}`;
    this.getLeftMove();
    this.$nextTick(() => {
      var left = document.getElementById("left");
      var box = document.getElementById("box");
      var right = document.getElementById("right");
      var pagination = document.getElementById("pagination");
      left.style.width = 250 + "px";
      right.style.width = box.clientWidth - 250 - 5 + "px";
      if (box.clientWidth - 250 - 5 < 1000) {
        document.getElementsByClassName(
          "ant-pagination"
        )[0].style.marginRight = 0;
        document.getElementsByClassName(
          "ant-pagination-options"
        )[0].style.display = "none";
      } else {
        document.getElementsByClassName("ant-pagination")[0].style.marginRight =
          "124px";
        document.getElementsByClassName(
          "ant-pagination-options"
        )[0].style.display = "block";
      }
      pagination.style.width = box.clientWidth - 250 + 5 + "px";
    });
  },
  methods: {
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.isCloseAll = false;
    },
    filterTree(arr, keyword, first = true) {
      if (first) {
        //首次传入深度克隆数据防止修改源数据
        arr = JSON.parse(JSON.stringify(arr));
      }
      let emptyArr = [];
      for (let item of arr) {
        if (item.title.includes(keyword)) {
          // if (item.children &&Array.isArray(item.children)&& item.children.length > 0) {
          //     item.children = this.filterTree(item.children, keyword,false);
          // }
          emptyArr.push(item);
          this.expandedKeys.push(item.key);
        } else if (
          item.children &&
          Array.isArray(item.children) &&
          item.children.length > 0
        ) {
          item.children = this.filterTree(item.children, keyword, false);
          if (item.children.length) {
            emptyArr.push(item);
            this.expandedKeys.push(item.key);
          }
        }
      }
      return emptyArr;
    },
    getLeftMove() {
      var resize = document.getElementById("resize");
      var left = document.getElementById("left");
      var right = document.getElementById("right");
      var box = document.getElementById("box");
      var pagination = document.getElementById("pagination");
      let _this = this;
      resize.onmousedown = function (e) {
        var startX = e.clientX;
        resize.left = resize.offsetLeft;
        document.onmousemove = function (e) {
          var endX = e.clientX;

          var moveLen = resize.left + (endX - startX);
          var maxT = box.clientWidth - resize.offsetWidth;
          if (moveLen < 250) moveLen = 250;
          if (moveLen > 600) moveLen = 600;
          if (moveLen > maxT - 150) moveLen = maxT - 150;

          resize.style.left = moveLen;
          left.style.width = moveLen + "px";
          right.style.width = box.clientWidth - moveLen - 5 + "px";
          if (box.clientWidth - moveLen - 5 < 1000) {
            _this.height = document.documentElement.clientHeight - 500;
            document.getElementsByClassName(
              "ant-pagination"
            )[0].style.marginRight = 0;
            document.getElementsByClassName(
              "ant-pagination-options"
            )[0].style.display = "none";
          } else {
            _this.height = document.documentElement.clientHeight - 480;
            document.getElementsByClassName(
              "ant-pagination"
            )[0].style.marginRight = "124px";
            document.getElementsByClassName(
              "ant-pagination-options"
            )[0].style.display = "block";
          }
          pagination.style.width = box.clientWidth - moveLen + 5 + "px";
        };
        document.onmouseup = function (evt) {
          document.onmousemove = null;
          document.onmouseup = null;
          resize.releaseCapture && resize.releaseCapture();
        };
        resize.setCapture && resize.setCapture();
        return false;
      };
    },
    search() {
      if(!this.value){
          this.expandedKeys = [this.treeData[0].key];
          return;
      }
      let newData = JSON.parse(JSON.stringify(this.treeData));
      this.treeData = this.filterTree(newData, this.value);
      this.isCloseAll = true;
    },
     closeTwo(){
       this.visibleDeils = false;
       this.getList();
    },
    close(){
       this.visibleDeils = false;
    },
    listSearch() {
      this.pagination.current = 1;
      this.getList();
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(page, pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getList();
    },
    selectedRowKeys(keys, selectedRows) {
      this.rowKeys = keys;
      this.selectDatas.push(...selectedRows);
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD;
    },
    see(item){
        this.itemData = item;
        this.visibleDeils = true;
    },
     getList() {
      this.loading = true;
      let startTime = "";
      let endTime = "";
      if (this.timeTwo.length > 0) {
        startTime = this.farmatDate(
          new Date(this.timeTwo[0].toString()).getTime(),
          "-"
        );
        endTime = this.farmatDate(
          new Date(this.timeTwo[1].toString()).getTime(),
          "-"
        );
      }
      findListPage({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        name: this.valueName,
        organizationId:this.organizationId,
        applyStage:this.applyStage,
        applicationSource:this.applicationSource,
        administrativeReview:this.administrativeReview,
        administrativeProceeding:this.administrativeProceeding,
        startTime,
        endTime,
      }).then((res) => {
        if (res.code == 0) {
          this.dataSource = JSON.parse(JSON.stringify(res.data.records));
          this.pagination.current = res.data.current;
          this.pagination.total = res.data.total;
          this.height = 0;
          if (this.pagination.total > 0) {
            var box = document.getElementById("box");
            if (box.clientWidth - 250 - 5 < 1000) {
              this.height = document.documentElement.clientHeight - 500;
            } else {
              this.height = document.documentElement.clientHeight - 480;
            }
            window.onresize = () => {
              return (() => {
                this.heightLeft = `${
                  document.documentElement.clientHeight - 200
                }`;
                var left = document.getElementById("left");
                var box = document.getElementById("box");
                var right = document.getElementById("right");
                var pagination = document.getElementById("pagination");
                left.style.width = 250 + "px";
                right.style.width = box.clientWidth - 250 - 5 + "px";
                if (box.clientWidth - 250 - 5 < 1000) {
                  this.height = document.documentElement.clientHeight - 500;
                  document.getElementsByClassName(
                    "ant-pagination"
                  )[0].style.marginRight = 0;
                  document.getElementsByClassName(
                    "ant-pagination-options"
                  )[0].style.display = "none";
                } else {
                  this.height = document.documentElement.clientHeight - 480;
                  document.getElementsByClassName(
                    "ant-pagination"
                  )[0].style.marginRight = "124px";
                  document.getElementsByClassName(
                    "ant-pagination-options"
                  )[0].style.display = "block";
                }
                pagination.style.width = box.clientWidth - 250 + 5 + "px";
              })();
            };
          }
          this.loading = false;
        }
      });
    },
    getThreeList() {
      const _this = this;
      this.treeLoading = true;
       this.loading = true;
      tree({
        columnName: this.value,
        siteId: sessionStorage.getItem("siteId"),
        orgIds: JSON.parse(sessionStorage.getItem("userInfo")).organizationId,
      }).then((res) => {
        if (res.code == 0) {
          let options = JSON.stringify(res.data)
            .replace(/organizationName/g, "title")
            .replace(/id/g, "key");
          _this.treeData = JSON.parse(options);
          _this.oldThreeData = _this.treeData;
          _this.organizationId = _this.treeData[0].key;
          _this.checkedKeys = [_this.treeData[0].key];
          _this.expandedKeys  = [_this.treeData[0].key];
          _this.organizationName = _this.treeData[0].title;
          this.treeLoading = false;
           this.getList();
        }
      });
    },
    onSelect(key, event) {
        if(key.length == 0){
            return;
        }
        this.organizationId = key[0];
        this.organizationName = event.node._props.title;
        this.checkedKeys = [this.organizationId];
        this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  display: flex;
  height: 100%;
  width: 100%;
  //position: relative;
  .left {
    width: 250px;
    font-size: 14px;
    border-right: solid 1px #f2f3f5;
    color: #000;
    padding: 24px;
    padding-top: 0px;
    .title {
      margin-bottom: 24px;
    }
    .search {
      margin-bottom: 12px;
    }
    /deep/ .ant-btn-primary {
      background: #1890ff;
      padding: 0 5px;
    }
    .ant-tree {
      min-height: 300px;
    }
    /deep/ input::-webkit-input-placeholder {
      color: #415058;
    }
    /deep/ .ant-input {
      background: #f7f7f7;
    }
    /deep/ .ant-btn-primary {
      color: #fff !important;
      background-color: #1890ff !important;
    }
  }
  .right {
    flex: 1;
    height: 100%;
    width: 100%;
    font-size: 14px;
    color: #000;
    width: 500px;
    .right-name {
      padding-left: 24px;
    }
    .search {
      display: flex;
      margin-right: 106px;
      margin-bottom: 20px;
      /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
    }
  }
}
.close-name {
  color: #303133;
  font-weight: 400;
  margin-top: 4px;
}
.close-img {
  margin-top: -1px;
  margin-right: 4px;
  cursor: pointer;
}
.right-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  margin-left: 17px;
  flex-wrap: wrap;
  .search {
    margin-left: 6px !important;
  }
  /deep/ .ant-btn,
  .ant-dropdown-trigger {
    height: 40px;
    background: #ecf5ff;
    color: #18abff;
    border-color: #c9e3ff;
    text-align: center;
  }
  /deep/ .ant-dropdown-menu-item {
    text-align: center;
  }
  /deep/ .ant-dropdown-trigger {
    border-radius: 3px;
    background-color: rgba(240, 246, 255, 1) !important;
    text-align: center;
    border: 1px solid rgba(23, 109, 230, 1) !important;
    color: rgba(23, 109, 230, 1) !important;
    font-size: 14px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-regular;
  }
}
.open-style {
  border-bottom: solid 1px #ccc;
  padding-bottom: 12px;
  padding-top: 12px;
  max-width: 200px;
}
.content {
  max-height: 400px;
  overflow-y: auto;
  width: 300px;
}

.table-th {
  width: 126px;
  height: 24px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Microsoft Yahei;
  text-align: center;
  line-height: 24px;
}
.table-tn {
  width: 60px;
  height: 24px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Microsoft Yahei;
  text-align: center;
  line-height: 24px;
}
.table_one {
  border: solid 1px #ccc;
  width: 100%;
}
.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 101px;
  border-radius: 5px;
}
.sort-box {
  width: 28px;
  height: 28px;
  background: #f5f7fa;
  text-align: center;
  line-height: 28px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .ant-btn {
    border: none;
    width: 100%;
    height: 100%;
    background: none;
  }
}
.sort-box-two {
  width: 28px;
  height: 28px;
  background: #f5f7fa;
  text-align: center;
  line-height: 28px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .ant-btn {
    border: none;
    width: 100%;
    height: 100%;
    background: none;
  }
}
.sort-two {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500 !important;
  cursor: pointer;
}
.sort-style {
  width: 43px;
  border: none;
  outline: none;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  flex: 1;
}
/deep/ .ant-pagination-options {
  float: left;
  margin-right: 58px;
}
/deep/ .ant-pagination-total-text {
  float: left;
}
/deep/ .ant-pagination-options-quick-jumper {
  position: absolute;
  right: 20px;
}
/deep/ .ant-pagination {
  margin-right: 124px;
}
.pagination {
  display: flex;
  padding: 12px;
  padding-right: 0px;
  justify-content: right;
  border-top: solid #f4f4f6 1px;
  position: absolute;
  bottom: 0;
  width: calc(100% - 529px);
  padding-right: 24px;
  bottom: 0px;
  margin-left: -5px;
}
/deep/ .ant-pagination-item-active {
  background: #1890ff;
}
/deep/ .ant-pagination-item-active a {
  color: #fff;
}
.zhi-ding {
  width: 40px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(237, 109, 103, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(237, 109, 103, 0.3);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
}
/deep/ .ant-spin-nested-loading {
  width: 100%;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 66px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 66px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-button--primary {
  background: #176de6;
}
.tui-song {
  width: 40px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(24, 109, 230, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(24, 109, 230, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
}

.icon-box-img {
  cursor: pointer;
}
#resize {
  width: 5px;
  height: 100%;
  cursor: w-resize;
  float: left;
}
.right-title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 24px;
  cursor: pointer;
  .right-title-box-txt {
    color: rgba(102, 111, 128, 1);
    font-size: 14px;
    text-align: right;
    font-family: Roboto-regular;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 70%;
  }
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 20px;
}
.column-box {
  .tree-box {
    height: 406px;
    overflow-y: auto;
    background: #f8f9fa;
  }
  /deep/.el-dialog__footer {
    padding-top: -5px;
    padding-bottom: 20px;
  }
  /deep/ .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 13px;
  }
  /deep/ .el-dialog__title {
    color: rgba(48, 49, 51, 1);
    font-size: 18px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-bold;
    font-weight: 600;
  }
  /deep/ .el-dialog__close {
    font-weight: 600;
  }
}
.choose-column-box {
  /deep/ .el-select {
    width: 100%;
  }
}
/deep/ .table {
  margin-top: 0px;
}
.search-box {
  position: absolute;
  right: 24px;
}
/deep/ .ant-tree.ant-tree-show-line li:not(:last-child)::before {
  border-left: 1px dashed rgba(187, 187, 187, 1);
}
.title-box {
  overflow: hidden; 
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration:underline;
  cursor: pointer;
  color: rgba(24, 109, 230, 1);
  }
  .tips-box{
    /deep/ .el-dialog__title{
        color: rgba(48, 49, 51, 1);
        font-size: 18px;
        font-family: Roboto-black;
        font-weight: bold;
      }
      /deep/ .el-dialog__body{
        padding: 10px 20px;
      }
  }
  .title-adoptin {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 8px 10px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  margin-bottom: 16px;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 3px;
    margin-right: 2px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
  .score-box{
  max-height: 256px;
  min-height: 100px;
  margin-top: 14px !important;
  overflow-y: auto;
  border-radius: 4px;
  text-align: left;
  border: 1px solid rgba(220, 223, 230, 1);
  margin-top: -10px;
  padding: 8px;
  padding-top: 0px;
  display: flex;
  justify-content: space-between;
	flex-wrap: wrap;
  /deep/ .el-checkbox__label{
    display: block;
    width: 100%;
    padding-left: 4px;
  }
  /deep/ .el-checkbox__input{
    margin-top: 3px;
  }
  .item {
    width: 42%;
    margin-top: 6px;
    display: flex;
    align-items: center;
    .item-txt{
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;
        width: 100%;
    }

}
}
/deep/ .el-checkbox:last-of-type{
  margin-right: 30px;
}
.box .search{
    padding: 0px !important;
}
</style>